import { apiFetch } from './apiFetch'
import { ActionError } from './ActionError'

// POSTs to an act endpoint and returns the parsed JSON body on success. Unlike
// fetchWithAuth, this preserves the HTTP status and the API's `message` body so
// callers can react to 409 conflicts / 404 not-found distinctly (see ActionError).
// Omit `body` for endpoints that must be called with no request body (e.g. the
// tenant_group redrive, whose schema rejects any payload).
export async function postAction(
  path: string,
  token: string,
  body?: object,
): Promise<{ message?: string }> {
  const response = await apiFetch(path, token, {
    method: 'POST',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    ...(body ? { body: JSON.stringify(body) } : {}),
  })

  let parsed: { message?: string } = {}
  try {
    parsed = (await response.json()) as { message?: string }
  } catch {
    parsed = {}
  }

  if (!response.ok) {
    throw new ActionError(
      response.status,
      parsed.message ?? `Request failed (${response.status})`,
    )
  }

  return parsed
}
